import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { omit } from 'lodash-es';
import { Button } from 'reactstrap';

import './opinion-button.scss';

export function OpinionButton({
  isActive = false,
  activeClassName = null,
  inactiveClassName = null,
  onClick = null,
  value,
  children = null,
  ...restButtonProps
}) {
  return (
    <Button
      onClick={onClick}
      value={value}
      className={classnames('opinion-button text-transform-none p-0_5', {
        [activeClassName]: isActive,
        [inactiveClassName]: !isActive,
      })}
      aria-pressed={isActive}
      data-tracking-id="opinion_button"
      {...omit(restButtonProps, ['activeButtonAdornment'])}
    >
      {children}
    </Button>
  );
}

OpinionButton.propTypes = {
  isActive: PropTypes.bool,
  activeClassName: PropTypes.string,
  inactiveClassName: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  children: PropTypes.node,
};
